import { formatPhoneNumber } from "react-phone-number-input";
import dayjs from "dayjs";
import { staticTextErrors } from "../config/constantErrorTexts.js";

const Utils = {
  debounce: (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  },
  getUrlParamsAsObject: (searchParams) => {
    if (!searchParams) return {}; // Return empty object if searchParams is null or undefined
    return Object.fromEntries(searchParams?.entries());
  },
  get_filtered_url_params(old_url_params, new_url_params) {
    if (!old_url_params && !new_url_params) return {};
    const old_params_as_object = this?.getUrlParamsAsObject(old_url_params);
    const filtered_params_as_object = Object?.fromEntries(
      Object?.entries({ ...old_params_as_object, ...new_url_params })?.filter(
        ([_, value]) => Boolean(value) || value === 0
      )
    );
    return filtered_params_as_object;
  },
  madeUnique: (items) => {
    return [...new Map(items?.map((item) => [item["id"], item]))?.values()];
  },
  getUrlInMap: (address) => {
    return `http://maps.apple.com/?q=${encodeURIComponent(address)}`;
  },
  format_phone_number: (phone_number) => {
    return phone_number ? formatPhoneNumber(phone_number) : "";
  },
  format_date: (date) => {
    return date ? dayjs(date)?.format("YYYY-MM-DD") : "";
  },
  format_date_time: (date) => {
    return date ? dayjs(date)?.format("YYYY-MM-DD hh:mm A") : "";
  },
  getTimeByMeasurment: (inputDate) => {
    const now = dayjs(); // Current time
    const parsedDate = dayjs(inputDate); // Parse input date
    const secondsDifference = now?.diff(parsedDate, "second"); // Difference in seconds
    const minutesDifference = now?.diff(parsedDate, "minute"); // Difference in minutes
    const hoursDifference = now?.diff(parsedDate, "hour"); // Difference in hours

    if (secondsDifference < 60) {
      return `${secondsDifference}s`; // Show seconds if less than a minute
    } else if (minutesDifference < 60) {
      return `${minutesDifference}m`; // Show minutes if less than an hour
    } else if (hoursDifference < 24) {
      return `${hoursDifference}h`; // Show hours if less than a day
    }

    return parsedDate?.format("MMM D"); // Format date as "Jan 7" if 24+ hours
  },
  mask_email: (email) => {
    if (!email?.includes("@")) return "";
    const [username, domain] = email?.split("@");
    if (!domain?.includes(".")) return "";
    const maskedUsername =
      username?.length <= 1
        ? username[0] + "\u2217"
        : username[0] +
          "\u2217"?.repeat(Math.max(username?.length - 2, 1)) +
          username?.slice(-1);
    const dotIndex = domain?.indexOf(".");
    const domainName = domain?.slice(0, dotIndex);
    const domainRest = domain?.slice(dotIndex);
    const maskedDomain =
      domainName[0] +
      "\u2217"?.repeat(domainName?.length - 1) +
      domainRest;
    return maskedUsername + "@" + maskedDomain;
  },
  mask_phone_number: (phone_number) => {
    const country_code = phone_number?.slice(1, 2);
    const clean_number = phone_number?.replace(/[^\d+]/g, "");
    const digits = clean_number?.startsWith("+1")
      ? clean_number?.substring(2)
      : clean_number?.substring(1);
    const last_two_digits = digits?.substring(8, 10);
    return `+${country_code} (\u2217\u2217\u2217) \u2217\u2217\u2217-\u2217\u2217${last_two_digits}`;
  },
  safe_mask_email: (email) => {
    if (!email) return "";
    if (email?.includes("\u2217") || email?.includes("*")) return email;
    return Utils?.mask_email(email);
  },
  safe_mask_phone: (phone) => {
    if (!phone) return "";
    if (phone?.includes("\u2217") || phone?.includes("*")) return phone;
    return Utils?.mask_phone_number(phone);
  },
  scrollIntoViewByClassName: (className) => {
    if (
      typeof className === "string" &&
      className &&
      className?.includes(".")
    ) {
      const element = document?.querySelector(className); // Select the element
      if (element) {
        element?.scrollIntoView({ behavior: "smooth" });
      }
    }
  },
  handleFormErrors: (errors, { formRef, onServerError }) => {
    if (!errors || typeof errors !== "object") return;
    for (let key in errors) {
      if (key === "SERVER_ERROR") {
        if (typeof onServerError === "function") {
          onServerError(errors[key] || staticTextErrors?.SERVER_ERROR);
        }
        formRef?.current?.resetFields();
        break;
      } else {
        formRef?.current?.setFields([
          {
            name: key,
            errors: Array.isArray(errors[key]) ? errors[key] : [errors[key]],
          },
        ]);
      }
    }
  },
};
export default Utils;
